"use client"

import clsx from "clsx"
import { FC } from "react"
import { Tooltip, TooltipProps } from "src/components/styled/Tooltip"
import { SpriteIconProps } from "src/components/unstyled/SpriteIcon"

export type ProviderIconData<IconName extends string> = {
  icon: IconName
  name: string
  background?: string
}

export type ProvidersProps<IconName extends string> = {
  Icon: FC<SpriteIconProps<IconName>>
  items: ProviderIconData<IconName>[]
  height: "lg" | "md" | "sm"
  tooltipVariant?: TooltipProps["variant"]
  className?: string
}

export function ProviderIcons<IconName extends string>({
  Icon,
  items,
  height,
  tooltipVariant,
  className,
}: ProvidersProps<IconName>) {
  return (
    <ul
      className={clsx("flex w-full flex-wrap items-center justify-center gap-2", {
        // These sizes match our button sizes which makes it look more harmonious.
        "h-13.5": height === "lg",
        "h-12": height === "md",
        "h-10": height === "sm",
      })}
    >
      {items.map((item, index) => {
        return (
          <Tooltip key={index} text={item.name} variant={tooltipVariant}>
            <li
              className={clsx(className, "rounded-md", {
                // These sizes match our button sizes which makes it look more harmonious.
                "h-13.5": height === "lg",
                "h-12": height === "md",
                "h-10": height === "sm",
              })}
              style={item.background ? { background: item.background } : undefined}
            >
              <Icon name={item.icon} className="size-full object-contain" />
            </li>
          </Tooltip>
        )
      })}
    </ul>
  )
}
